import {IForm} from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'empId',
      type: 'input',
      label: '企微账号',
      placeholder: '请输入企微账号',
      rules: {required: true, message: '企微账号是必传的', trigger: 'blur'},
      isDisabled: false
    },
    {
      field: 'corpId',
      type: 'select',
      label: '所属主体',
      placeholder: '请选择所属主体',
      rules: {required: true, message: '所属主体是必选的', trigger: 'blur'},
      options: [
        {title: '天鼎证券投顾', value: 'ww3535c85e83b16e9e'}
      ],
      isDisabled: false
    },
    {
      field: 'welcome',
      type: 'textarea',
      label: '欢迎语',
      placeholder: '请输入欢迎语'
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
